$(document).ready(function() {

  function viewAlert(theme, message, color) {
    $.smallBox({
      title: theme,
      content: message,
      color: color,
      timeout: 4000,
      icon: "fa fa-bell swing animated"
    });
  }

  $('body').on(
    'click', '.users-access input', function()
    {
    var access = $(this).val();
    var user_id = $(this).data('user');
    var access_checked = $(this).is(':checked');

    $.ajax({
      url: '/ajax/addAccess',
      type: 'POST',
      data: {
        YII_CSRF_TOKEN: token,
        access: access,
        access_checked: access_checked,
        user: user_id
      }
    })
      .done(function (response) {
        response = JSON.parse(response);
        if (response.code == 0) {
          viewAlert(translate.rights_caption, translate.rights_success_message, '#739E73');
        } else {
          viewAlert(translate.rights_caption, translate.rights_error_message, '#C46A69');
        }
      })
  });

  $('body').on(
    'click', '.block-user', function()
    {
    var that = $(this);
    var user_id = $(this).data('user');

    $.SmartMessageBox({
      title: translate.user_block_account_caption,
      content: translate.user_block_account_message,
      buttons: '[' + translate.button_no + '][' + translate.button_yes + ']'
    }, function (ButtonPressed) {
      if (ButtonPressed === translate.button_yes) {

        $.ajax({
          url: '/ajax/blockCustomer',
          type: 'POST',
          data: {
            YII_CSRF_TOKEN: token,
            customer_id: user_id
          }
        })
          .done(function (response) {
            response = JSON.parse(response);
            if (response.code == 0) {
              viewAlert(translate.user_block_dialog_caption, translate.user_block_dialog_message, '#739E73');

              that
                .removeClass('block-user').addClass('unblock-user')
                  .removeClass('text-danger').addClass('text-success')
                    .html('<i class="fa fa-check"></i> ' + translate.button_activate);

              that.parents('tr').find('.user-name').removeClass('text-success').addClass('text-danger')
                .find('i').removeClass('fa-check').addClass('fa-times');
            } else {
              viewAlert(translate.user_block_dialog_caption, translate.user_block_dialog_error_message, '#C46A69');
            }
          })
      }
    });
  });

  $('body').on('click', '.resend-invite', function () {
    var that = $(this);
    var user_id = $(this).data('user');

    if(that.parent().hasClass("loading-bg")) {
      return;
    }

    that.parent().addClass("loading-bg");

    $.ajax({
      url: '/ajax/resendUserInvite',
      type: 'POST',
      data: {
        YII_CSRF_TOKEN: token,
        manager_id: user_id
      }
    }).done(function (response) {
      that.parent().removeClass("loading-bg");
      response = JSON.parse(response);
      if (response.code == 0) {
        viewAlert(translate.alert_success_caption, translate.email_resent, '#739E73');
      } else {
        viewAlert(translate.alert_danger_caption, translate.failed_to_send, '#C46A69');
      }
    });
  });

  $('body').on(
    'click', '.unblock-user', function()
    {
    var that = $(this);
    var user_id = $(this).data('user');

    $.SmartMessageBox({
      title: translate.user_activate_account_caption,
      content: translate.user_activate_account_message,
      buttons: '[' + translate.button_no + '][' + translate.button_yes + ']'
    }, function (ButtonPressed) {
      if (ButtonPressed === translate.button_yes) {

        $.ajax({
          url: '/ajax/activateCustomer',
          type: 'POST',
          data: {
            YII_CSRF_TOKEN: token,
            customer_id: user_id
          }
        })
          .done(function (response) {
            response = JSON.parse(response);
            if (response.code == 0) {
              viewAlert(translate.user_activate_dialog_caption, translate.user_activate_dialog_message, '#739E73');

              that
                .removeClass('unblock-user').addClass('block-user')
                  .removeClass('text-success').addClass('text-danger')
                .html('<i class="fa fa-times"></i> ' + translate.button_block);

              that.parents('tr').find('.user-name').removeClass('text-danger').addClass('text-success')
                .find('i').removeClass('fa-times').addClass('fa-check');
            } else {
              viewAlert(translate.user_activate_dialog_caption, translate.user_activate_dialog_error_message, '#C46A69');
            }
          })
      }
    });
  });

  $('#User_email').focusout(function(event) {
    event.preventDefault();

    $.ajax({
        url:  '/ajax/findUser',
        type: 'POST',
        data: {
          YII_CSRF_TOKEN: token,
          email: $(this).val()
        }
      })
      .done(function (response) {
        response = JSON.parse(response);
        if (response.code == 0) {
          $('#User_password').prop('disabled', 'disabled');
          $('#User_password_repeat').prop('disabled', 'disabled');
          $('#User_first_name').val(response.response.first_name).prop('disabled', 'disabled');
          $('#User_last_name').val(response.response.last_name).prop('disabled', 'disabled');
          $('#User_phone').val(response.response.phone).prop('disabled', 'disabled');
        }
      })
  })

});
